import {
  CButton,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
} from "@coreui/react"
import { Flex, Input, Select, Typography } from "antd"
import React, { useState } from "react"
import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { addAbonementStructure } from "src/store/Slices/AbonementsSlice"
import { openNotification } from "src/components/helpers/notification"
import { AbonementStructure } from "src/store/Slices/AbonementsSlice"

const AddNewAbonementStructure = ({
  visible,
  setVisible,
  abonementInfo,
  payload,
}) => {
  // HELPERS
  const dispatch = useDispatch()

  const [name, setName] = useState()
  const [description, setDescription] = useState()

  const onClickAddAbonementStructure = () => {
    dispatch(
      addAbonementStructure({
        abonementId: abonementInfo.id,
        itemName: name,
        itemDescription: description,
      })
    )
      .then(() => {
        dispatch(
          AbonementStructure({
            abonementId: abonementInfo.id,
          })
        )
      })
      .then(() => {
        setVisible(false)
      })
  }

  return (
    <CModal
      alignment='center'
      visible={visible}
      aria-labelledby='VerticallyCenteredExample'
      onClose={() => {
        setVisible(false)
      }}
      keyboard={true}
    >
      <CModalHeader>
        <CModalTitle id='VerticallyCenteredExample'>
          {"Добавить состав абонемента"}
        </CModalTitle>
      </CModalHeader>
      <CModalBody
        style={{
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        <Flex vertical gap={16} style={{ marginTop: "20px" }}>
          <>
            <div>
              <Typography.Title level={5}>Имя элемента</Typography.Title>
              <Input
                defaultValue=''
                value={name}
                onChange={(e) => setName(e.currentTarget.value)}
              />
            </div>
            <Typography.Title level={5}>Описание элемента</Typography.Title>
            <div>
              <Input
                defaultValue=''
                value={description}
                onChange={(e) => setDescription(e.currentTarget.value)}
              />
            </div>
          </>
        </Flex>
      </CModalBody>
      <CModalFooter>
        <CButton
          onClick={() => {
            setVisible(false)
          }}
          style={{ color: "#fff" }}
          color='secondary'
        >
          Закрыть
        </CButton>
        <CButton
          onClick={onClickAddAbonementStructure}
          style={{ color: "#fff" }}
        >
          Добавить
        </CButton>
      </CModalFooter>
    </CModal>
  )
}

export default AddNewAbonementStructure
